/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Defaultcontent1Inputs */

const id_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan masukkan ulasan Anda di sini`)
};

const ms_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila masukkan ulasan anda di sini`)
};

const da_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast venligst din anmeldelse her`)
};

const de_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie Ihre Bewertung hier ein`)
};

const en_us2_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your review here`)
};

const es_es2_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, escribe tu reseña aquí`)
};

const es_mx2_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, escribe tu reseña aquí`)
};

const fil_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mangyaring ilagay ang iyong review dito`)
};

const fr_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez écrire votre avis ici`)
};

const it_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci la tua recensione qui`)
};

const hu_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérjük, írd ide az értékelésed`)
};

const nl_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer hier je review in`)
};

const no_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vennligst skriv omtalen din her`)
};

const pl_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisz swoją recenzję tutaj`)
};

const pt_br2_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your review here`)
};

const pt_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira a sua avaliação aqui`)
};

const ro_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te rugăm să introduci recenzia aici`)
};

const fi_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjoita arvostelusi tähän`)
};

const sv_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vänligen skriv din recension här`)
};

const vi_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập đánh giá của bạn tại đây`)
};

const tr_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen yorumunuzu buraya girin`)
};

const cs_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosím napište svou recenzi zde`)
};

const bg_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моля, напишете вашето ревю тук`)
};

const ru_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, напишите Ваш обзор здесь`)
};

const uk_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будь ласка, введіть ваш відгук тут`)
};

const ar_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى إدخال مراجعتك هنا`)
};

const hi_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी समीक्षा दर्ज करें`)
};

const th_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรุณาป้อนรีวิวของคุณที่นี่`)
};

const ja_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここにレビューを入力してください`)
};

const zh_cn2_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your review here`)
};

const zh_hant1_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your review here`)
};

const ko_forms_review_defaultcontent1 = /** @type {(inputs: Forms_Review_Defaultcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your review here`)
};

/**
* | output |
* | --- |
* | "Please enter your review here" |
*
* @param {Forms_Review_Defaultcontent1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_defaultcontent1 = /** @type {((inputs?: Forms_Review_Defaultcontent1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Defaultcontent1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_defaultcontent1(inputs)
	if (locale === "ms") return ms_forms_review_defaultcontent1(inputs)
	if (locale === "da") return da_forms_review_defaultcontent1(inputs)
	if (locale === "de") return de_forms_review_defaultcontent1(inputs)
	if (locale === "en-US") return en_us2_forms_review_defaultcontent1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_defaultcontent1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_defaultcontent1(inputs)
	if (locale === "fil") return fil_forms_review_defaultcontent1(inputs)
	if (locale === "fr") return fr_forms_review_defaultcontent1(inputs)
	if (locale === "it") return it_forms_review_defaultcontent1(inputs)
	if (locale === "hu") return hu_forms_review_defaultcontent1(inputs)
	if (locale === "nl") return nl_forms_review_defaultcontent1(inputs)
	if (locale === "no") return no_forms_review_defaultcontent1(inputs)
	if (locale === "pl") return pl_forms_review_defaultcontent1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_defaultcontent1(inputs)
	if (locale === "pt") return pt_forms_review_defaultcontent1(inputs)
	if (locale === "ro") return ro_forms_review_defaultcontent1(inputs)
	if (locale === "fi") return fi_forms_review_defaultcontent1(inputs)
	if (locale === "sv") return sv_forms_review_defaultcontent1(inputs)
	if (locale === "vi") return vi_forms_review_defaultcontent1(inputs)
	if (locale === "tr") return tr_forms_review_defaultcontent1(inputs)
	if (locale === "cs") return cs_forms_review_defaultcontent1(inputs)
	if (locale === "bg") return bg_forms_review_defaultcontent1(inputs)
	if (locale === "ru") return ru_forms_review_defaultcontent1(inputs)
	if (locale === "uk") return uk_forms_review_defaultcontent1(inputs)
	if (locale === "ar") return ar_forms_review_defaultcontent1(inputs)
	if (locale === "hi") return hi_forms_review_defaultcontent1(inputs)
	if (locale === "th") return th_forms_review_defaultcontent1(inputs)
	if (locale === "ja") return ja_forms_review_defaultcontent1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_defaultcontent1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_defaultcontent1(inputs)
	return ko_forms_review_defaultcontent1(inputs)
});
export { forms_review_defaultcontent1 as "forms.review.defaultContent" }